import React from 'react';
import { Sparkles } from 'lucide-react';
import GlobalSearch from './GlobalSearch';

const Header = ({ currentView, analysisCategory, config, useMockData, onGlobalSearchNavigate }) => {

  const getTitle = () => {
    if (currentView === 'dashboard') return 'Executive Dashboard';
    if (currentView === 'data-quality') return 'Data Quality Report';
    if (currentView === 'ideal-client') return 'Ideal Client Profile';
    if (currentView === 'what-if') return 'What-If Scenario Analyzer';
    if (currentView === 'plan-groups') return 'OC Plan Groups';
    if (currentView === 'workload-agent') return 'Workload Decision Agent';
    if (currentView === 'plan-config') return 'Plan Configuration';
    if (currentView === 'executive') return 'Executive Summary';
    if (currentView === 'upload') return 'Data Upload';
    if (currentView === 'settings') return 'Settings';
    if (currentView === 'tk-analyst') return 'TK Analyst';
    if (currentView === 'plan-timeline') return 'Plan Timeline';
    if (currentView === 'revenue-timeline') return 'Revenue Timeline';
    if (currentView === 'revenue-tracker') return 'Revenue Tracker';
    if (currentView === 'client-ladder') return 'Revenue Detail';
    if (currentView === 'risk-register') return 'Risk Register';
    if (currentView === 'revenue-per-lot') return 'Revenue per Lot';
    if (currentView === 'nps-analysis') return 'NPS Analytics';
    if (currentView === 'deep-dive') return 'Plan Group Deep Dive';
    if (currentView === 'value-proposition') return 'TK Value Proposition';
    if (currentView === 'proposal') return 'Committee Proposal';
    if (currentView === 'manager-deep-dive') return 'Manager Deep Dive';
    if (currentView === 'team-leader-deep-dive') return 'Team Leader Deep Dive';
    if (currentView === 'performance-ladder') return 'Performance Ladder';
    if (currentView === 'workload-analysis') return 'Workload Analysis';
    if (currentView === 'team-structure') return 'Team Structure';
    if (analysisCategory === 'manager') return 'Manager Analysis';
    if (analysisCategory === 'tl') return 'Team Leader Analysis';
    return `${analysisCategory.charAt(0).toUpperCase() + analysisCategory.slice(1)} Analysis`;
  };

  return (
    <header className="h-14 border-b border-[#E5E5E5] flex items-center px-6 justify-between sticky top-0 z-10 bg-white">
      <div className="flex items-center gap-3">
        <h2 className="text-[15px] font-semibold text-[#171717] tracking-tight font-heading">
          {getTitle()}
        </h2>
      </div>
      
      <div className="flex items-center gap-2">
        {/* Global Search */}
        <GlobalSearch onNavigate={onGlobalSearchNavigate} />

        {/* Cost Badge */}
        <div className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#F5F5F5] border border-[#E5E5E5]">
          <span className="text-[10px] font-medium text-[#737373]">Cost Basis</span>
          <span className="text-xs font-bold text-[#171717]">
            ${config?.costPerHour || 60}/hr
          </span>
        </div>

        {/* AI Badge */}
        <div className="hidden md:flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-[#171717]">
          <Sparkles className="w-3 h-3 text-white" />
          <span className="text-[10px] font-semibold text-white">AI</span>
        </div>

        {/* Mock Data Indicator */}
        {useMockData && (
          <div className="hidden md:flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-amber-50 border border-amber-200">
            <span className="text-[10px] font-medium text-amber-700">Sample Data</span>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
